module.exports = __webpack_public_path__ + "media/site/images/lock-illustration-b798d9862e0379f144c6563eab4605fa.svg";